// Generated by scripts/observability-contracts.ts. Edit the canonical browser operation catalog.
import type { BROWSER_OPERATION_CONTRACTS } from './browser-operation'

const values = [
  "email",
  "email_canvas",
  "persisted",
  "server_action",
  "convex",
  "email_inventory",
  "send_dialog",
  "email_persist",
  "generated",
  "sending",
  "response",
  "audience",
  "audience_grid",
  "contact_add",
  "contact_create",
  "contact_sheet",
  "domains",
  "domain_settings",
  "provider_response",
  "verification",
  "credential_ready",
  "domain_share",
  "settings",
  "organization_switcher",
  "session_ready",
  "clerk",
  "organization_create",
  "team_settings",
  "account_settings",
  "api_settings",
  "integrations",
  "channel_link",
  "chat",
  "chat_composer",
  "accepted",
  "email_groups",
  "uploads",
  "image_upload",
  "staged",
  "http",
  "brand_library",
  "upload_index",
  "staged_and_submitted",
  "upload_batch"
] as const
const rows: ReadonlyArray<readonly [string, number, number, number, number, number?]> = [
  ["email.group.rename",0,1,2,3],
  ["email.layout.persist",0,1,2,4],
  ["email.clone",0,5,2,3],
  ["email.delete",0,5,2,3],
  ["email.group.move",0,5,2,3],
  ["email.subject.persist",0,6,2,3,7],
  ["email.preview.persist",0,6,2,3,7],
  ["email.subject.generate",0,6,8,3],
  ["email.preview.generate",0,6,8,3],
  ["send.contacts.query",9,6,10,3],
  ["send.contacts.summary",9,6,10,3],
  ["send.variables.coverage",9,6,10,3],
  ["audience.counts.refresh",11,12,10,3],
  ["contact.create",11,13,2,3,14],
  ["contact.update",11,15,2,3],
  ["contact.field.define",11,15,2,3],
  ["audience.field.define",11,11,2,3],
  ["domain.create",16,17,2,3],
  ["domain.delete",16,17,2,3],
  ["domain.settings.persist",16,17,2,3],
  ["domain.verify",16,17,18,3,19],
  ["domain.share.create",16,17,20,3],
  ["domain.share.verify",16,21,18,3,19],
  ["domain.entri.prepare",16,17,20,3],
  ["organization.switch",22,23,24,25],
  ["organization.create",22,26,2,25],
  ["organization.rename",22,27,2,25],
  ["organization.logo.persist",22,27,2,25],
  ["organization.leave",22,27,2,3],
  ["organization.memberships.query",22,27,10,25],
  ["organization.invitation.accept",22,23,2,25],
  ["team.member.role",22,27,2,3],
  ["team.member.remove",22,27,2,3],
  ["team.invitation.revoke",22,27,2,3],
  ["account.profile.persist",22,28,2,25],
  ["account.avatar.persist",22,28,2,25],
  ["api_key.brands.page",22,29,10,3],
  ["api_key.create",22,29,20,3],
  ["api_key.revoke",22,29,2,3],
  ["api_key.rotate",22,29,20,3],
  ["channel.link",30,31,2,3,31],
  ["chat.stop.request",32,33,34,4],
  ["email.preview.schedule",0,35,34,4],
  ["email.preview.compose",0,35,10,3],
  ["upload.image.prepare",36,37,38,39],
  ["upload.image.import",36,37,38,39],
  ["upload.brand.submit",36,40,34,39,41],
  ["upload.brand.session",36,40,24,39],
  ["upload.brand.batch",36,40,42,39,43]
]

export const BROWSER_OPERATION_RUNTIME_CONTRACTS = Object.fromEntries(
  rows.map(([key, domain, surface, phase, transport, result]) => [key, {
    domain: values[domain],
    surface: values[surface],
    phase: values[phase],
    transport: values[transport],
    ...(result === undefined ? {} : { result: values[result] }),
  }])
) as typeof BROWSER_OPERATION_CONTRACTS
